module.exports = __webpack_public_path__ + "img/banner.6426505d.png";